import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  InputSignal,
  output,
  Signal,
  ViewEncapsulation,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AtIconComponent, AtSkeletonComponent, COMMON_DICTIONARY, CommonDictionary } from '@anothertrip/anothertrip-ds';

import { CookieConsentService } from '../../services/cookie-consent/cookie-consent.service';

@Component({
  standalone: true,
  selector: 'app-user-profile-overlay',
  imports: [RouterLink, RouterLinkActive, AtIconComponent, AtSkeletonComponent],
  templateUrl: './user-profile-overlay.component.html',
  styleUrl: './user-profile-overlay.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'umenu' },
})
export class UserProfileOverlayComponent {
  protected readonly dictionary = inject<CommonDictionary>(COMMON_DICTIONARY);
  private readonly cookieConsent = inject(CookieConsentService);

  readonly isUserLoading: InputSignal<boolean> = input<boolean>(false);
  readonly username: InputSignal<string | undefined> = input<string | undefined>(undefined);
  readonly email: InputSignal<string | undefined> = input<string | undefined>(undefined);
  /** Id of the visually hidden "Account" heading, which the host's overlay is labelled by. */
  readonly headingId: InputSignal<string | null> = input<string | null>(null);

  // eslint-disable-next-line @angular-eslint/no-output-native -- `close` matches the overlay's dismiss semantics; renaming would break parent bindings
  readonly close = output<void>();
  readonly logout = output<void>();

  protected readonly initials: Signal<string> = computed<string>(() =>
    (this.username() ?? '?')
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('')
  );

  /**
   * The menu closes first, and the order matters. Closing makes the overlay refocus its trigger, and the
   * kit returns focus on close to whatever held it when it opened. Open first and that is this row, which
   * is gone by then, so focus falls to `main` and a keyboard user is thrown back to the top of the page.
   */
  protected openCookieSettings(): void {
    this.close.emit();
    this.cookieConsent.openSettings();
  }
}
